import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { usePwaInstall } from "@/lib/usePwaInstall";
import { Button } from "@/components/ui/button";
import { Film, Download } from "lucide-react";
import MobileNav from "@/components/app/MobileNav";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { canInstall, install } = usePwaInstall();
  return (
    <>
      <header className="glass-header sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-full bg-[var(--em-clay)] grid place-items-center text-white">
              <Film size={16} strokeWidth={2.2} />
            </span>
            <span className="font-serif-em text-xl tracking-tight">Chapter</span>
          </Link>
          <nav className="flex items-center gap-3">
            {canInstall && (
              <Button variant="outline" size="sm" onClick={install} data-testid="header-install-btn" className="hidden md:inline-flex rounded-full">
                <Download size={14} className="mr-1.5" /> Install app
              </Button>
            )}
            {user ? (
              <>
                <Link to="/dashboard" className="text-sm text-[var(--em-ink-soft)] hover:text-[var(--em-ink)]" data-testid="header-dashboard-link">Dashboard</Link>
                <Button variant="outline" size="sm" onClick={() => { logout(); navigate("/"); }} data-testid="header-logout-btn">Sign out</Button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm text-[var(--em-ink-soft)] hover:text-[var(--em-ink)]" data-testid="header-login-link">Sign in</Link>
                <Button
                  size="sm"
                  onClick={() => navigate("/signup")}
                  className="bg-[var(--em-clay)] hover:bg-[var(--em-clay-deep)] text-white rounded-full px-5 btn-lift"
                  data-testid="header-signup-btn"
                >Start a memory</Button>
              </>
            )}
          </nav>
        </div>
      </header>
      <MobileNav />
    </>
  );
}
